import { CommentDotsRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";

const GroupTextActivity = ({ activity, onReadChange }) => {
  const queryParams = new URLSearchParams();
  queryParams.set("tab", "3");

  return (
    <ActivityContainer activity={activity} queryParams={queryParams.toString()} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer
            containerClassName="tw-bg-[#FAF1E6] tw-text-[#AD6714]"
            Icon={CommentDotsRegularV6}
          >
            New Group Message
          </CategoryContainer>
        }
        personName={`${activity.data.senderFirstName} ${activity.data.senderLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <span className={`${STYLES.lineClamp3} tw-px-8px`}>{activity.content}</span>
    </ActivityContainer>
  );
};

export default GroupTextActivity;

GroupTextActivity.propTypes = {
  ...activityCommonPropTypes,
};

GroupTextActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
